/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func,
    object, bool,
} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import style from './BYODetailsDialog.module.css';
import byoTheme from './BYOTheme';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import FoodDetailsExpansionPanel from '../../../GraphqlFoodDetailsUI/v2/FoodDetailsExpansionPanel';
import ResponsiveImage from '../../../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const BYODetailsDialog = ({
    selectedOption,
    addRemoveItem,
    added,

}) => {
    const buildImgPath = (path, name) => `${path + name}x.jpg?width=354&height=358&auto=webp`;
    useStyles(style);
    const brandData = useSelector(getBrand);
    const brandCode = brandData?.code;
    const {
        buttonColorSelect = '#512C1C',
    } = byoTheme[brandCode] || {};
    const {
        filledColorBg = '#512C1C',
    } = byoTheme[brandCode] || {};
    return (
        <>
            <div className={style.dialogContent}>
                <div className={style.imageContainer}>
                    <ResponsiveImage className={style.productImage} path={buildImgPath(selectedOption?.image?.path, selectedOption?.image?.name)} alt={selectedOption.name || 'productItem'} params={{ desktop: 'quality=100', tablet: 'quality=100', mobile: 'quality=100' }} />
                </div>
                <div
                    className={style.bottomContent}
                    style={{
                        '--btn-filled-color': filledColorBg,
                    }}
                >
                    <p className={style.productName}>{ReactHtmlParser(selectedOption?.name)}</p>
                    {selectedOption?.longDescription &&  <FoodDetailsExpansionPanel summary="Contents" details={ReactHtmlParser(selectedOption.longDescription)} panelId={1} expanded={!selectedOption.shortDescription} pdpInlineAddon byoLabelDesign={style.header} />}
                    {selectedOption?.shortDescription && <FoodDetailsExpansionPanel summary="Description" details={ReactHtmlParser(selectedOption.shortDescription)} panelId={2}  expanded={selectedOption.shortDescription} pdpInlineAddon byoLabelDesign={style.header} />}
                </div>
            </div>
            <div
                className={style.buttonMainContainer}
                style={{
                    '--btn-selected-color': buttonColorSelect,
                }}
            >
                <button
                    type="button"
                    data-testid="cyoBandButton"
                    variant="outlined"
                    className={style.buttonContainer}
                    onClick={() => addRemoveItem(selectedOption)}
                >
                    {added ? (
                        <div className={style.selectedButton}>
                            Selected
                            <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
                        </div>
                    ) : (
                        'Select'
                    )}
                </button>
            </div>
        </>
    );
};
BYODetailsDialog.propTypes = {
    selectedOption: object.isRequired,
    added: bool.isRequired,
    addRemoveItem: func.isRequired,
};
export default BYODetailsDialog;
